const WeatherDataSource = {
	NONE: "",
	ICON: "ICON by Deutscher Wetterdienst",
	DWD: "Deutscher Wetterdienst",
	NOAA: "National Oceanic and Atmospheric Administration",
	METEO: "Météo-France",
	METO: "UK MetOffice",
	FCOO: "Danish Defence Centre for Operational Oceanography",
	FMI: "Finnish Meteorological Institution",
	YR: "Norwegian Meteorological Institute and NRK",
	SMHI: "Swedish Meteorological and Hydrological Institute",
	SG: "Storm Glass"
};
export default WeatherDataSource;
